module.exports = __webpack_public_path__ + "img/blackbook.b2abd760.png";